import { marked } from 'marked'

export default defineNuxtPlugin(() => {
  const parsedText = (md: string | undefined) => (md ? marked.parse(md) : '')

  return {
    provide: {
      md: parsedText,
    },
  }
})
